// export const HERRAMIENTA_CREAR_TEXTO_USUARIO_ID = "Texto";
export var SEPARADOR_ID = '-';
/** GRUPO TEXTO */

export var GRUPO_TEXTO = 'Texto';
export var TEXTO_ID = 'Texto';
export var NOTA_ID = 'Nota';
export var VINCULO_ID = 'Vinculo';
export var ELIMINAR_NOTAS_ID = 'EliminarNotas';
/** GRUPO PIZARRA */

export var GRUPO_PIZARRA = 'Pizarra';
export var PUNTERO_ID = "Puntero";
export var LAPIZ_ID = "Lapiz";
export var LAPIZ_GROSOR_ID = "LapizGrosor";
export var LAPIZ_COLOR_ID = "LapizColor";
export var MARCADOR_ID = "Marcador";
export var MARCADOR_GROSOR_ID = "MarcadorGrosor";
export var MARCADOR_COLOR_ID = "MarcadorColor";
export var BORRADOR_ID = "Borrador";
export var BORRADOR_GROSOR_ID = "BorradorGrosor";
export var ELIMINAR_DIBUJOS_ID = "EliminarDibujos";
/** GRUPO MASCARAS */

export var GRUPO_MASCARAS = "Mascaras";
export var ENMASCARAR_ID = "Enmascarar";
export var FOCO_ID = "Foco";
export var PERSIANA_ID = "Persiana";
export var RESETEAR_ID = "Resetear";
/** GRUPO GENERAL */
// export const HERRAMIENTA_OCULTAR_FOCO_ID = "OcultarFoco";

export var GRUPO_GENERAL = "General";
export var MOSTRAR_ID = "Mostrar";
export var ELIMINAR_TODO_ID = "EliminarTodo";
export var RELOJ_ID = "Reloj";
/** VALORES POR DEFECTO */

export var GROSORES_LAPIZ_POR_DEFECTO = [5, 15, 25];
export var COLORES_LAPIZ_POR_DEFECTO = ['#ff0000', '#00ff00', '#0000ff', '#000000', '#ffffff'];
export var GROSORES_MARCADOR_POR_DEFECTO = [10, 20, 35];
export var COLORES_MARCADOR_POR_DEFECTO = ['#ff0000', '#00ff00', '#0000ff'];
export var GROSORES_BORRADOR_POR_DEFECTO = [5, 25, 50];
export var BOTONES_POR_DEFECTO = [{
  grupo: GRUPO_TEXTO,
  id: TEXTO_ID
}, {
  grupo: GRUPO_TEXTO,
  id: ELIMINAR_NOTAS_ID
}, {
  id: SEPARADOR_ID
}, {
  grupo: GRUPO_PIZARRA,
  id: PUNTERO_ID
}, {
  grupo: GRUPO_PIZARRA,
  id: LAPIZ_ID,
  grosores: GROSORES_LAPIZ_POR_DEFECTO,
  colores: COLORES_LAPIZ_POR_DEFECTO
}, {
  grupo: GRUPO_PIZARRA,
  id: MARCADOR_ID,
  grosores: GROSORES_MARCADOR_POR_DEFECTO,
  colores: COLORES_MARCADOR_POR_DEFECTO
}, {
  grupo: GRUPO_PIZARRA,
  id: BORRADOR_ID,
  grosores: GROSORES_BORRADOR_POR_DEFECTO
}, {
  grupo: GRUPO_PIZARRA,
  id: ELIMINAR_DIBUJOS_ID
}, {
  id: SEPARADOR_ID
}, {
  grupo: GRUPO_GENERAL,
  id: MOSTRAR_ID
}, {
  grupo: GRUPO_GENERAL,
  id: ELIMINAR_TODO_ID
}];
export var BARRA_HERRAMIENTAS_POR_DEFECTO = {
  visible: true,
  posicion: {
    x: 10,
    y: 70
  },
  botones: BOTONES_POR_DEFECTO,
  herramientaIdSeleccionado: PUNTERO_ID
};
export var HERRAMIENTAS_NO_SELECCIONABLES = [ELIMINAR_DIBUJOS_ID, ELIMINAR_NOTAS_ID, ELIMINAR_TODO_ID, RESETEAR_ID, RELOJ_ID];